export interface IProjectConfig {
  defaultPhoto: string;
}

export const PROJECT_CONFIG = 'PROJECT_CONFIG';

export const projectConfig: IProjectConfig = {
  defaultPhoto: '/assets/images/svg/default-photo.svg'
};



// WEBPACK FOOTER //
// ./app/core/constants/project-config.constant.ts